import { queryOptions } from '@tanstack/react-query';

import { crownApi } from '@/common/api/crownQueryClient';

export const getThemingQuery = queryOptions({
  queryFn: async () => (await crownApi.Meta_getTheming()).data,
  queryKey: ['theming'],
});
